// extracted by mini-css-extract-plugin
export var activityContainer = "_ml-0";
export var typingIndicatorContainer = "_ml-1";
export var typingIndicatorDot = "_ml-2";
export var wave = "_ml-3";